import { defineMessages } from 'react-intl';

export default defineMessages({
  learnHowLink: {
    id: 'frontbucket.commitList.learnHowLink',
    description: 'A link to more information about creating commits.',
    defaultMessage: 'Learn how',
  },
  description: {
    id: 'frontbucket.commitList.emptyStateDescription',
    description: 'Descriptive text on commit-list empty state screen',
    defaultMessage: 'Each commit tracks a set of changes to your repository.',
  },
  header: {
    id: 'frontbucket.commitList.overview.emptyStateHeader',
    description: 'Header of commit-list empty state screen',
    defaultMessage: 'Commit to your changes',
  },
});
